import React from 'react'

interface VerifiedProps {
  size?: number
  color?: string
}

export const Verified: React.FC<VerifiedProps> = ({
  size = 24,
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.87255 14.224C1.98774 13.6904 0.99992 13.0324 1 11.9992C1.00008 10.9666 1.98649 10.3089 2.87105 9.77631C3.31679 9.50793 3.67002 9.12102 3.87193 8.63381C4.07348 8.14697 4.09759 7.62424 3.97287 7.12008C3.72471 6.1169 3.4909 4.95285 4.2215 4.22196C4.95198 3.4912 6.11574 3.72423 7.11866 3.97274C7.62331 4.09779 8.14647 4.07379 8.63369 3.87209C9.12059 3.67053 9.50704 3.31792 9.77513 2.87312C10.3086 1.98802 10.9665 0.999998 11.9999 1C13.0334 1 13.6913 1.98801 14.2248 2.87303C14.493 3.31791 14.8796 3.67045 15.3661 3.87209C15.853 4.07363 16.3757 4.09775 16.8799 3.97303C17.8831 3.72487 19.0471 3.49106 19.778 4.22166C20.5088 4.95213 20.2757 6.11588 20.0272 7.11879C19.9022 7.62343 19.9262 8.14659 20.1279 8.63381C20.3295 9.1207 20.6821 9.50715 21.1269 9.77524C22.012 10.3087 23 10.9666 23 12C23 13.0334 22.012 13.6913 21.127 14.2249C20.6821 14.4931 20.3295 14.8796 20.1279 15.3662C19.9263 15.853 19.9022 16.3758 20.0269 16.8799C20.2751 17.8831 20.5089 19.0471 19.7783 19.778C19.0478 20.5088 17.8841 20.2758 16.8812 20.0273C16.3765 19.9022 15.8533 19.9262 15.3661 20.1279C14.8792 20.3295 14.4928 20.6821 14.2247 21.1269C13.6912 22.012 13.0333 23 11.9999 23C10.9665 23 10.3086 22.012 9.77499 21.127C9.50677 20.6821 9.12024 20.3295 8.63369 20.1279C8.14684 19.9264 7.62411 19.9023 7.11995 20.027C6.11676 20.2751 4.9527 20.5089 4.22181 19.7783C3.49104 19.0479 3.72407 17.8841 3.97258 16.8812C4.09763 16.3766 4.07363 15.8534 3.87193 15.3662C3.67031 14.8791 3.31754 14.4924 2.87255 14.224Z"
        fill="#2970FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 8.29289C17.0976 8.68342 17.0976 9.31658 16.7071 9.70711L11.2071 15.2071C11.0196 15.3946 10.7652 15.5 10.5 15.5C10.2348 15.5 9.98043 15.3946 9.79289 15.2071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L10.5 13.0858L15.2929 8.29289C15.6834 7.90237 16.3166 7.90237 16.7071 8.29289Z"
        fill="white"
      />
    </svg>
  )
}
